module.exports = __webpack_public_path__ + "static/media/introAPPgreen.bedd113a.mp4";